import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

import { TestSetting } from "./_types"

const getPath = (testName: string) => `/test-pattern?test_name=${testName}`

export const fetchTestSetting = defineFetcher((testName: string): Promise<TestSetting> => {
  return GET(getPath(testName))
})
